import React from 'react';
import {View, StyleSheet, TextInput} from 'react-native';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';

type SearchFieldProps = {
  onChangeText: (text: string) => void;
  strings: typeof Localized;
  value: string;
};

const SearchField = (props: SearchFieldProps) => (
  <View style={styles.searchField}>
    <FontAwesome5Pro
      name="search"
      color={Styles.auxColor}
      size={Styles.Fonts.f2}
      solid
    />
    <TextInput
      style={styles.searchText}
      placeholder={`${props.strings.Labels.search}...`}
      onChangeText={props.onChangeText}
      clearButtonMode="while-editing"
      value={props.value}
      accessibilityLabel="Search"
      nativeID="Search"
    />
  </View>
);

const styles = StyleSheet.create({
  searchField: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: Styles.Spacing.m2,
    marginHorizontal: Styles.Spacing.m3,
    padding: Styles.Spacing.m2,
    borderRadius: 4,
    backgroundColor: Styles.bgColor,
    alignItems: 'center',
  },
  searchText: {
    flex: 1,
    fontSize: Styles.Fonts.f1,
    marginLeft: Styles.Spacing.m2,
  },
});

export default SearchField;
